import React from 'react';
import { ShieldCheck, Leaf, Globe2 } from 'lucide-react';

const pillars = [
  {
    icon: ShieldCheck,
    text: 'Digital identity and governance infrastructure that strengthens trust, accountability, and public-sector capability.',
  },
  {
    icon: Leaf,
    text: 'Environmental and sustainability frameworks that transform compliance obligations into measurable commercial value.',
  },
  {
    icon: Globe2,
    text: 'Regulatory and market-access solutions that facilitate investment, trade, and cross-border economic participation across Africa.',
  },
];

const About = () => {
  return (
    <section id="about" className="relative py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-12 md:mb-16 lg:mb-20">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#3eb5a0] mb-4">
            About Us
          </h2>
        </div>

        {/* Content */}
        <div className="max-w-5xl">
          <p className="text-lg md:text-xl text-[#2d2d2d]/80 leading-relaxed mb-6 md:mb-8 font-light" style={{ lineHeight: '1.8' }}>
            <span className="font-medium text-[#2d2d2d]">Reshadi Investments and Projects (Pty) Ltd</span> is
            a South African RegTech company focused on building the operating infrastructure that
            connects policy, compliance, and execution at scale.
          </p>

          <p className="text-lg md:text-xl text-[#2d2d2d]/80 leading-relaxed mb-6 md:mb-8 font-light" style={{ lineHeight: '1.8' }}>
            We work where legislation, industry, and digital governance intersect, creating systems
            that enable governments, regulators, and markets to implement regulatory frameworks with
            greater efficiency, transparency, and economic impact.
          </p>

          <p className="text-lg md:text-xl text-[#2d2d2d]/80 leading-relaxed mb-6 md:mb-8 font-light" style={{ lineHeight: '1.8' }}>
            Our approach is built on three strategic pillars:
          </p>

          <ul className="space-y-4 md:space-y-5 mb-8 md:mb-10 list-none" data-testid="about-pillars">
            {pillars.map((item, i) => {
              const Icon = item.icon;
              return (
                <li
                  key={i}
                  data-testid={`about-pillar-${i}`}
                  className="flex items-start gap-4 md:gap-5"
                >
                  <span
                    aria-hidden="true"
                    className="flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-lg bg-[#3eb5a0]/10 border border-[#3eb5a0]/30 flex items-center justify-center mt-0.5"
                  >
                    <Icon size={18} className="text-[#3eb5a0]" strokeWidth={2} />
                  </span>
                  <span
                    className="text-lg md:text-xl text-[#2d2d2d]/80 font-light pt-1"
                    style={{ lineHeight: '1.8' }}
                  >
                    {item.text}
                  </span>
                </li>
              );
            })}
          </ul>

          <p className="text-lg md:text-xl text-[#2d2d2d]/80 leading-relaxed mb-6 md:mb-8 font-light" style={{ lineHeight: '1.8' }}>
            Reshadi does not develop standalone products. We design and operate foundational
            infrastructure that supports regulatory implementation, institutional growth, and
            long-term economic development.
          </p>

          <p className="text-lg md:text-xl text-[#2d2d2d]/80 leading-relaxed font-light" style={{ lineHeight: '1.8' }}>
            As African markets modernise and regulatory requirements evolve, our platforms are
            engineered to increase in value, enabling governments, industries, and investors to move
            from policy ambition to practical execution.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
